module.exports = __webpack_public_path__ + "media/steps/loader_icon_3_old-663931fa.png";